import { SsoAcceptActionTypes } from './ssoAccept.types';

export const initialState = {
  loading: false,
  error: null,
};

const ssoAcceptReducer = (state = initialState, action) => {
  switch (action.type) {
    case SsoAcceptActionTypes.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SsoAcceptActionTypes.SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case SsoAcceptActionTypes.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default ssoAcceptReducer;
